import { render, staticRenderFns } from "./ConsultasMain.vue?vue&type=template&id=165b4966&scoped=true&"
import script from "./ConsultasMain.vue?vue&type=script&lang=js&"
export * from "./ConsultasMain.vue?vue&type=script&lang=js&"
import style0 from "./ConsultasMain.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ConsultasMain.vue?vue&type=style&index=1&id=165b4966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b4966",
  null
  
)

export default component.exports